/**
 * RotaSla
 * @author Gil
 */
import {Collection, ID, Model, Resource, ResponseSerialize} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import PontaSla from '@/model/resource/PontaSla'

export default class RotaSla extends Resource {
  readonly $name: string = 'RotaSla'
  readonly $endpoint: string = '/user/rota-sla'

  $id: ID = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(PontaSla)
  origem: PontaSla | null = null

  @ResponseSerialize(PontaSla)
  destino: PontaSla | null = null

  valor: number | null = null

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }

  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  get idOrigemFk() {
    if (!this.origem) return 0
    return this.origem.$id
  }

  set idOrigemFk(idOrigemFk: ID) {
    if (!this.origem) this.origem = new PontaSla()
    this.origem.$id = idOrigemFk
  }

  get idDestinoFk() {
    if (!this.destino) return 0
    return this.destino.$id
  }

  set idDestinoFk(idDestinoFk: ID) {
    if (!this.destino) this.destino = new PontaSla()
    this.destino.$id = idDestinoFk
  }
}
